import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./CollectionsDemo.css";

const CollectionsDemo = () => {
  const [mode, setMode] = useState("list");
  const [listItems, setListItems] = useState(["яблоко", "банан", "киви"]);
  const [newItem, setNewItem] = useState("");

  const [tupleItems] = useState(["один", "два", "три"]);

  const [setItems, setSetItems] = useState(new Set([1, 2, 3]));
  const [setValue, setSetValue] = useState("");

  const [dictItems, setDictItems] = useState({ name: "Alice", age: 30 });
  const [dictKey, setDictKey] = useState("");
  const [dictValue, setDictValue] = useState("");

  const addItem = () => {
    if (!newItem) return;
    setListItems(prev => [...prev, newItem]);
    setNewItem("");
  };
  const removeItem = (item) => {
    setListItems(prev => prev.filter(i => i !== item));
  };

  const addSetItem = () => {
    setSetItems(prev => new Set(prev).add(setValue));
    setSetValue("");
  };
  const removeSetItem = (item) => {
    setSetItems(prev => {
      const copy = new Set(prev);
      copy.delete(item);
      return copy;
    });
  };

  const addDictEntry = () => {
    if (!dictKey) return;
    setDictItems(prev => ({ ...prev, [dictKey]: dictValue }));
    setDictKey(""); setDictValue("");
  };
  const removeDictEntry = (key) => {
    setDictItems(prev => {
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });
  };

  return (
    <div className="collections-demo">
      <h3>Интерактивный обзор коллекций</h3>
      <div className="modes">
        {["list","tuple","set","dict"].map(m => (
          <button
            key={m}
            className={mode === m ? "active" : ""}
            onClick={() => setMode(m)}
          >
            {m === "list" ? "Список" : m === "tuple" ? "Кортеж" : m === "set" ? "Множество" : "Словарь"}
          </button>
        ))}
      </div>

      <div className="content">
        {mode === "list" && (
          <div className="list-demo">
            <div className="items">
              <strong>Текущий список:</strong>
              <AnimatePresence>
                {listItems.map(item => (
                  <motion.div
                    key={item}
                    initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}
                    className="item"
                  >
                    {item}
                    <button onClick={() => removeItem(item)}>×</button>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>
            <div className="controls">
              <input value={newItem} onChange={e => setNewItem(e.target.value)} placeholder="Новый элемент" />
              <button onClick={addItem}>Добавить</button>
            </div>
          </div>
        )}

        {mode === "tuple" && (
          <div className="tuple-demo">
            <strong>Кортеж (неизменяемый):</strong>
            <div className="items">
              {tupleItems.map((v,i) => (
                <span key={i} className="item">{v}</span>
              ))}
            </div>
            <p>Попытка изменить кортеж невозможна.</p>
          </div>
        )}

        {mode === "set" && (
          <div className="set-demo">
            <div className="items">
              <strong>Множество:</strong>
              {[...setItems].map(item => (
                <span key={item} className="item">{item}
                  <button onClick={() => removeSetItem(item)}>×</button>
                </span>
              ))}
            </div>
            <div className="controls">
              <input value={setValue} onChange={e => setSetValue(e.target.value)} placeholder="Значение" />
              <button onClick={addSetItem}>Добавить</button>
            </div>
          </div>
        )}

        {mode === "dict" && (
          <div className="dict-demo">
            <div className="items">
              <strong>Словарь:</strong>
              {Object.entries(dictItems).map(([key,val]) => (
                <div key={key} className="item">
                  <span className="dict-key">{key}:</span> {val}
                  <button onClick={() => removeDictEntry(key)}>×</button>
                </div>
              ))}
            </div>
            <div className="controls">
              <input value={dictKey} onChange={e => setDictKey(e.target.value)} placeholder="Ключ" />
              <input value={dictValue} onChange={e => setDictValue(e.target.value)} placeholder="Значение" />
              <button onClick={addDictEntry}>Добавить / Обновить</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CollectionsDemo;